import { ChangeDetectionStrategy, Component, computed, Input, inject, signal } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LanguagePreferenceService } from '@services/domain/language-preference.service';
import { SUPPORTED_LANGUAGES } from 'app/core/i18n/languages';

@Component({
	selector: 'app-lang-switcher',
	imports: [TranslocoModule],
	templateUrl: './lang-switcher.component.html',
	styleUrl: './lang-switcher.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LangSwitcherComponent {
	@Input() isFloating = false;

	private readonly transloco = inject(TranslocoService);
	private readonly preference = inject(LanguagePreferenceService);

	readonly languages = SUPPORTED_LANGUAGES;
	readonly activeLang = signal(this.transloco.getActiveLang());
	readonly isFloatingMenuOpen = signal(false);
	readonly isActive = computed(() => (lang: string) => this.activeLang() === lang);

	constructor() {
		this.transloco.langChanges$.subscribe((lang) => this.activeLang.set(lang));
	}

	setLang(lang: string): void {
		this.preference.choose(lang).subscribe();
		this.activeLang.set(lang);
	}

	toggleFloatingMenu(): void {
		this.isFloatingMenuOpen.set(!this.isFloatingMenuOpen());
	}

	selectLanguage(lang: string): void {
		this.setLang(lang);
		this.isFloatingMenuOpen.set(false);
	}

	labelKey(lang: string): string {
		return `languages.${lang}`;
	}
}
